// Widget Scripts
import headerButton from './js/widgets/headerButton.js';
import mainSlider from './js/widgets/mainSlider.js';
import eventsWidget from './js/widgets/eventsWidget.js';
import cardsWidget from './js/widgets/cardsWidget.js';
import videoWidget from './js/widgets/videoWidget.js';
import * as socialNetworkWidget from './js/widgets/socialWidget.js';
import sponsors from './js/widgets/sponsors.js';
import footerGallery from './js/widgets/footerGalleryWidget.js';
// Custom Theme Scripts
import './js/localjs.js';

// Initialize Homepage Widgets

$(document).ready(function () {
  // Initialize Custom Theme Scripts
  headerButton();
  footerGallery();

  if (window.location.pathname === '/') {
    mainSlider();
    eventsWidget();
    cardsWidget();
    $(globalThis).on('load', function () {
      videoWidget();
      socialNetworkWidget.facebookfeed(true);
    });
    sponsors();
  }
});
